import React from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import zhCnMessages from './zh_cn';

function getTranscriptLocale(locale) {
  switch (locale) {
    case 'en_GB':
      return 'en';
    case undefined:
    case null:
      return require('@config/i18nConfig.json').locale;
    default:
      return locale;
  }
}

function getMessagesForLocale(locale) {
  switch (locale) {
    case 'zh_CN':
      return zhCnMessages;
    default:
      return undefined;
  }
}

const ConnectedIntlProvider = ({ children, locale }) => (
  <IntlProvider
    key={getTranscriptLocale(locale)}
    locale="en"
    messages={getMessagesForLocale(locale)}
  >
    {children}
  </IntlProvider>
);

const mapStateToProps = (state) => ({
  locale: state.conference.locale,
});

export default connect(mapStateToProps)(ConnectedIntlProvider);



// WEBPACK FOOTER //
// ./Intl/index.js